<template>
  <div class="columns is-multiline pdt-0">
    <div class="column is-3">
      <b-field
        :label="$t('nomenclatureTechnique.field.nomenclatureType')"
        :message="alert.message"
        :type="alert.type">
        <b-select
          v-model="nomenclatureTypeSelected"
          @input="onselected"
          :disabled="disabled"
          expanded>
          <option :value="null"></option>
          <option
            v-for="el in nomenclatureType"
            :value="el.id" :key="el.id">
            {{ el.libelle }}
          </option>
        </b-select>
      </b-field>
    </div>
    <div class="column is-12" v-if="item.nomenclatureTypeId && mountedEnd">
      <qd-json-form
        v-model="item.nomenclature"
        :schema="schema"
        :disabled="disabled">
      </qd-json-form>
    </div>
    <b-modal v-model="openPopUpPrevention" has-modal-card class="modal"
             :can-cancel="false">
      <pop-up-prevention
        :mess-header="$t('nomenclatureTechnique.warning.dataLoss')"
        :cancel="$t('general.button.cancel')"
        :validate="$t('general.button.next')"
        @yes="updateNomenclatureType"
        @no="cancelChangeNomenclatureType">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { REFERENCE_TYPE_TECHNIQUE } from '@/configuration/parametrage/nomenclatureTypeConf';
import popUpPrevention from '@/components/general/popUpPrevention';
import qdJsonForm from '@/components/parametrage/nomenclature/qdJsonForm';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    item: {
      type: Object,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  components: {
    popUpPrevention,
    qdJsonForm,
  },
  data() {
    return {
      mountedEnd: false,
      openPopUpPrevention: false,
      nomenclatureTypeSelected: null,
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    nomenclatureType() {
      return this.parametre(
        typesParametres.PARAMETRES_KEYS.nomenclatureType,
      ).filter(el => el.reference === REFERENCE_TYPE_TECHNIQUE
        && (el.actif || el.id === this.item.nomenclatureTypeId));
    },
    schema() {
      const find = this.nomenclatureType.find(el => el.id === this.item?.nomenclatureTypeId);
      if (!find) return {};
      return JSON.parse(find.schema);
    },
    alert() {
      const find = this.nomenclatureType.find(el => el.id === this.item?.nomenclatureTypeId);
      if (!find || find.actif) return { message: '', type: '' };
      return {
        message: this.$t('nomenclatureTechnique.warning.nomenclatureTypeArcive'),
        type: 'is-warning',
      };
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    updateNomenclatureType() {
      this.item.nomenclatureTypeId = this.nomenclatureTypeSelected;
      this.item.nomenclature = null;
      this.openPopUpPrevention = false;
    },
    cancelChangeNomenclatureType() {
      this.nomenclatureTypeSelected = this.item?.nomenclatureTypeId;
      this.openPopUpPrevention = false;
    },
    onselected() {
      this.openPopUpPrevention = !!this.item?.nomenclatureTypeId
        && (this.item.nomenclatureTypeId !== this.nomenclatureTypeSelected);
      if (!this.openPopUpPrevention) this.item.nomenclatureTypeId = this.nomenclatureTypeSelected;
    },
  },
  async mounted() {
    try {
      await this.loadParametres([
        typesParametres.PARAMETRES_KEYS.nomenclatureType,
      ]);
      this.nomenclatureTypeSelected = this.item?.nomenclatureTypeId;
      this.mountedEnd = true;
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
